import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidTaxpayerFirstNameError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.company.validation.taxpayer-first-name.not-empty');
    }
}
